/*
 * File: /src/store/modules/aiAgents.js
 * Author: AdBase, Inc.
 * Copyright (c) 2024 AdBase, Inc.
 */

import AiAgentService from 'src/services/aiAgentService';

const state = {
  aiAgents: undefined
};

const getters = {
  getAiAgents: state => state.aiAgents
};

const actions = {
  async fetchAiAgents({ commit, state }) {
    // Only load the data once
    if (state.aiAgents == undefined) {
      return AiAgentService.fetchAll()
        .then(r => {
          commit('setAiAgents', r.data);
        });
    }
  },
  unloadAiAgents({ commit }) {
    commit('setAiAgents', undefined);
  },
};

const mutations = {
  setAiAgents(state, aiAgents) {
    state.aiAgents = aiAgents;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
